import { styled } from '@mui/material';

export const StyledProgressContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1)
}));
